/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService } from '../../../../core/services';
import { ErrorResponseModel } from '../../../../core/models';
import { Injectable } from '@angular/core';
import { ModulesEnum } from '../../../../core/enums';
import { Observable, Subscriber } from 'rxjs';
import { ViewConfEnum } from '../enums/api';

@Injectable()
export class ViewConfigurationApiService {
    constructor(
        private apiService: ApiService,
        private authStoreService: AuthStoreService
    ) {
    }

    /**
     * Get individual config.
     * @param module
     * @param config
     * @param options
     */
    public getConfig(module: string, config: string, options?: any): Observable<any> {
        return new Observable((observer: Subscriber<any>): void => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.apiService.get(ViewConfEnum.GET_CONFIG(module, config), moduleAuth)
                .subscribe({
                    next: (data: any): void => {
                        observer.next(data);
                        observer.complete();
                    },
                    error: (error: ErrorResponseModel): void => {
                        observer.error(error);
                        observer.complete();
                    }
                });
        });
    }

    /**
     * Get ALL configs.
     * @param options
     */
    public getConfigs(options?: any): Observable<any> {
        return new Observable((observer: Subscriber<any>): void => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.apiService.get(ViewConfEnum.GET_CONFIGS, moduleAuth)
                .subscribe({
                    next: (data: any): void => {
                        observer.next(data);
                        observer.complete();
                    },
                    error: (error: ErrorResponseModel): void => {
                        observer.error(error);
                        observer.complete();
                    }
                });
        });
    }
}
